import React from "react";
import {
  FaCoins,
  FaCube,
  FaFileContract,
  FaChartPie,
  FaLink,
  FaExchangeAlt,
  FaWallet,
  FaShieldAlt,
} from "react-icons/fa";

function TokenCreation() {
  return (
    <>
      <div className="team-single-area default-padding">
        <div className="container">
          <div className="team-single-items">
            <div className="row">
              {/* LEFT IMAGE */}
              <div className="col-lg-5 left-info">
                <div className="thumb fade-up-anim">
                  <img
                    src="https://validthemes.net/site-template/robok/assets/img/team/10.jpg"
                    alt="Thumb"
                  />
                </div>
              </div>

              {/* RIGHT CONTENT */}
              <div className="col-lg-7 right-info">
                <div className="container">
                  <div className="col-lg-12">
                    <div className="site-heading">
                      <h4 className="sub-title">Our Services</h4>
                      <h2 className="title split-text-right split-text-in-right split-lines">
                        Our Cryptocurrency Token Development Services
                      </h2>
                    </div>
                  </div>
                </div>

                <div className="container">
                  <div className="services-style-four-items">
                    {/* 1 */}
                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaCoins size={40} />
                      </div>
                      <h4>Custom Coin Development</h4>
                      <p>
                        Creation of tailored cryptocurrencies tokens or coins
                        designed to meet specific business needs and use cases.
                      </p>
                    </div>

                    {/* 2 */}
                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaCube size={40} />
                      </div>
                      <h4>Token Creation</h4>
                      <p>
                        Development of various types of tokens, including
                        utility tokens, security tokens, and governance tokens.
                      </p>
                    </div>

                    {/* 3 */}
                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaFileContract size={40} />
                      </div>
                      <h4>Smart Contract Development</h4>
                      <p>
                        Designing and deploying secure smart contracts that
                        automate transactions and enhance functionality.
                      </p>
                    </div>

                    {/* 4 */}
                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaChartPie size={40} />
                      </div>
                      <h4>Tokenomics Strategy</h4>
                      <p>
                        Consultation on developing a robust tokenomics model,
                        including supply, distribution, and incentive
                        mechanisms.
                      </p>
                    </div>

                    {/* 5 */}
                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaLink size={40} />
                      </div>
                      <h4>Blockchain Integration</h4>
                      <p>
                        Seamless integration of your coin with existing
                        blockchain networks, ensuring optimal performance and
                        scalability.
                      </p>
                    </div>

                    {/* 6 */}
                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaExchangeAlt size={40} />
                      </div>
                      <h4>Decentralized Exchange (DEX) Development</h4>
                      <p>
                        Building decentralized exchanges for trading your coin,
                        enhancing liquidity and user accessibility.
                      </p>
                    </div>

                    {/* 7 */}
                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaWallet size={40} />
                      </div>
                      <h4>Wallet Development</h4>
                      <p>
                        Creating secure wallets for storing, managing, and
                        transacting your coins with user-friendly interfaces.
                      </p>
                    </div>

                    {/* 8 */}
                    <div className="services-style-four-item">
                      <div className="icon">
                        <FaShieldAlt size={40} />
                      </div>
                      <h4>Security Audits and Testing</h4>
                      <p>
                        Conducting comprehensive security assessments and audits
                        to identify and resolve vulnerabilities before launch.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default TokenCreation;
